import { action } from 'typesafe-actions';
import {
  IAnnealedWireType,
  IDiameter,
  IPieceType,
  ISteelType,
  Types
} from './types';

export const loadPieceTypes = () => action(Types.LOAD_PIECE_TYPES);
export const loadPieceTypesSuccess = (pieceTypes: IPieceType[]) =>
  action(Types.LOAD_PIECE_TYPES_SUCCESS, { pieceTypes });
export const loadPieceTypesFailure = (error: unknown) =>
  action(Types.LOAD_PIECE_TYPES_FAILURE, { error });

export const loadSteelTypes = () => action(Types.LOAD_STEEL_TYPES);
export const loadSteelTypesSuccess = (steelTypes: ISteelType[]) =>
  action(Types.LOAD_STEEL_TYPES_SUCCESS, { steelTypes });
export const loadSteelTypesFailure = (error: unknown) =>
  action(Types.LOAD_STEEL_TYPES_FAILURE, { error });

export const loadSteelTypeDiameters = (steelTypeId: number) =>
  action(Types.LOAD_STEEL_TYPE_DIAMETERS, { steelTypeId });
export const loadSteelTypeDiametersSuccess = (
  steelTypeId: number,
  diameters: IDiameter[]
) =>
  action(Types.LOAD_STEEL_TYPE_DIAMETERS_SUCCESS, { steelTypeId, diameters });
export const loadSteelTypeDiametersFailure = (
  steelTypeId: number,
  error: unknown
) => action(Types.LOAD_STEEL_TYPE_DIAMETERS_FAILURE, { steelTypeId, error });

export const loadWireTypes = (
  annealedWireIds: string[],
  selectedContractNumber: string
) => action(Types.LOAD_WIRE_TYPES, { annealedWireIds, selectedContractNumber });
export const loadWireTypesSuccess = (wireTypes: IAnnealedWireType[]) =>
  action(Types.LOAD_WIRE_TYPES_SUCCESS, { wireTypes });
export const loadWireTypesFailure = (error: unknown) =>
  action(Types.LOAD_WIRE_TYPES_FAILURE, { error });
